(function () {

	const initUnbundlerCart = () => {

        console.log('initUnbundlerCart');
        
        let bundled_item = document.querySelector('.bundle-item');
    
        // add bundle title
        if(window.localStorage.getItem('bundle_added_title')) {
            bundled_item.querySelector('.plan-title').text = window.localStorage.getItem('bundle_added_title');
        }

        // change bundle image
        if(bundled_item.querySelector('.bundle-item-flex[data-mainimage]')) {
            bundled_item.querySelector('.cart-item__image').src = bundled_item.querySelector('.bundle-item-flex[data-mainimage]').dataset.mainimage;
        }

        // clear cart action
        bundled_item.querySelectorAll('cart-remove-button').forEach((remove_btn) => {
            remove_btn.addEventListener('click', async (e) =>{
                e.preventDefault();
                await fetch('/cart/clear.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                });

                // Reload the current page
                window.location.reload();
            });
        });
            
    };

	document.addEventListener("shopify:section:load", function () {
		initUnbundlerCart();
	});

	initUnbundlerCart();
})();